import React, { useEffect, useState } from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout';
import StateComponents from '../../../../components/state-component/StateComponents';
import { MENU_RENDER_VIEW_ENUM } from '../menu/enum.menu';
import { BannerApi, createdBanner } from '../../../../api/banner/banner.api';
import ModalMedia from '../../media/modal-media/ModalMedia';
import { linkPreviewImage } from '../../../../components/upload-image-preview/UploadImagePreview';
import { alertError, alertSuccess } from '../../../../components/alert/swal';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
// import { RoutePath } from '../../../routes/Routes';
import { createSearchParams, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ContainerButton from '../../../../components/button/ContainerButton';
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom';
import moment from 'moment';
import { getBaseApi } from '../../../../utils/app.utils';
// import { STATUS_DATA } from '../../../../constants/enum';
import { routeName } from '../../../../routes/routeName';
import { banner_group_data } from './enum/enum';

type Props = {
    view: boolean;
}

enum MODE_DATA {
    SUBMIT = "SUBMIT",
    DRAFT = "DRAFT"
}
const BannerSlideDetail: React.FC<Props> = ({
    view
}: Props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const group_type = searchParams.get('group_type');

    const [image_upload, set_image_upload] = useState<File[]>([]);
    const [is_public, set_is_public] = useState<boolean>(false);
    const [formState, setFormState] = useState<createdBanner>({
        banner_desc: "",
        banner_end_date: moment().add(10, 'year').format("YYYY-MM-DD"),
        banner_link: "",
        banner_name: "",
        banner_start_date: "",
        banner_status_open: MENU_RENDER_VIEW_ENUM.CURRENT_TAB,
        id_media_file: null,
        is_public: false,
        seq: null,
        banner_end_time: moment().format("HH:mm"),
        banner_start_time: "",
        banner_group: group_type ?? ""
    })
    const [errorMessage, setErrorMessage] = useState<{ banner_link: string, banner_name: string, seq: string }>({
        banner_link: "",
        banner_name: "",
        seq: ""
    })

    const clearErrorMessage = () => setErrorMessage({ banner_link: "", banner_name: "", seq: "" })
    const handleChangeFormState = (field: string, value: any) => {
        setFormState((prev) => ({ ...prev, [field]: value }))
    }

    const [showModal, setShowModal] = useState<string>("")
    const [id_media_file, set_id_media_file] = useState<number | null>(null);
    const [file_api_url, set_file_api_url] = useState<string>("");

    const handleCloseModal = () => {
        setShowModal("");
    }

    const generateForm = (id_media_file?: number, mode?: "DRAFT" | "SUBMIT"): createdBanner => {
        const start_date = formState.banner_start_date
            ? moment(
                `${moment(formState.banner_start_date).format("YYYY-MM-DD")}${formState.banner_start_time ? ` ${formState.banner_start_time}` : ''}`
            ).format(formState.banner_start_time ? "YYYY-MM-DD[T]HH:mm" : "YYYY-MM-DD")
            : "";

        const end_date = formState.banner_end_date
            ? moment(
                `${moment(formState.banner_end_date).format("YYYY-MM-DD")}${formState.banner_end_time ? ` ${formState.banner_end_time}` : ''}`
            ).format(formState.banner_end_time ? "YYYY-MM-DD[T]HH:mm" : "YYYY-MM-DD")
            : "";
        return {
            banner_desc: formState.banner_desc,
            banner_group: formState.banner_group,
            banner_link: formState.banner_link,
            banner_name: formState.banner_name,
            banner_status_open: formState.banner_status_open,
            is_public: formState.is_public ? true : false,
            seq: formState.seq ? +formState.seq : null,
            banner_end_date: end_date,
            banner_start_date: start_date,
            id_media_file: id_media_file ?? null,
        }
    }
    const validate_data = (mode?: "DRAFT" | "SUBMIT"): boolean => {
        let is_not_valid: boolean = false;
        if (!formState.seq) {
            setErrorMessage((prev) => ({ ...prev, seq: "ระบุลำดับ" }))
            is_not_valid = true
        }
        if (!formState.banner_name) {
            setErrorMessage((prev) => ({ ...prev, banner_name: "กรุณาระบุชื่อ" }))
            is_not_valid = true
        }
        if (!formState.banner_link && mode === MODE_DATA.SUBMIT) {
            setErrorMessage((prev) => ({ ...prev, banner_link: "กรุณาระบุลิงก์เชื่อมโยง" }))
            is_not_valid = true
        }

        return is_not_valid
    }
    const handleSubmit = async (mode: "DRAFT" | "SUBMIT", id_media_file?: number) => {
        const validate = validate_data(mode);
        if (validate) return false;
        const body = generateForm(id_media_file, mode);
        dispatch(setLoading());
        if (id) {
            await BannerApi.update(+id, body).then((res) => {
                if (res.status < 300) {
                    alertSuccess('อัพเดตแบนเนอร์', 'อัพเดตแบนเนอร์ เรียบร้อยแล้ว')
                    handleGetDetail(+id)
                }
            }).catch((err) => {
                console.log(err, 'err')
                alertError('อัพเดตแบนเนอร์', err.response.data.message || 'อัพเดตแบนเนอร์ ไม่สำเร็จ')
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await BannerApi.createBanner(body).then((res) => {
                if (res.status < 300) {
                    const id_banner = res.data?.data?.id_banner;
                    alertSuccess('เพิ่มแบนเนอร์', 'เพิ่มแบนเนอร์ เรียบร้อยแล้ว')
                    if (id_banner && mode === 'DRAFT') {
                        setTimeout(() => {
                            window.location.replace(routeName.cms_website.website_structure_banner_slide_detail.replace(":id", id_banner))
                        }, 700)
                    } else {
                        navigate({
                            pathname: routeName.cms_website.website_structure_banner_slide,
                            search: createSearchParams({
                                group_type: group_type ?? ""
                            }).toString()
                        })
                    }

                }
            }).catch((err) => {
                console.log(err, 'err')
                alertError('เพิ่มแบนเนอร์', err.response.data.message || 'เพิ่มแบนเนอร์ ไม่สำเร็จ')
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }
    // const handleUpdateStatus = async (id_banner: number, is_public: number) => {
    //     await BannerApi.updateStatus(id_banner, {
    //         is_public: is_public
    //     }).then((res) => {
    //         if (res.status < 300) {
    //             handleGetDetail(id_banner);
    //         }
    //     }).catch((err) => {
    //         console.log(err)
    //         alertError("อัพเดตสถานะไม่สำเร็จ")
    //     })
    // }


    const handleGetDetail = async (id_banner: number) => {
        dispatch(setLoading());
        await BannerApi.findOne(id_banner).then((res) => {
            if (res.status < 300) {
                const data = res.data?.data;
                const banner_file = data?.banner_file || null;
                const path_public: string = getBaseApi();
                let path_data: string = banner_file ? `${path_public}/${banner_file?.media_file_path}${banner_file?.media_file_name}` : '';
                if (banner_file) {
                    set_file_api_url(path_data)
                }
                set_is_public(!!data?.is_public);
                set_id_media_file(data?.id_media_file || null);
                setFormState((prev) => ({
                    ...prev,
                    banner_desc: data?.banner_desc,
                    banner_start_date: data?.banner_start_date,
                    // banner_start_time: data?.banner_start_time,
                    // banner_end_time: data?.banner_end_time,
                    banner_end_date: data?.banner_end_date,
                    banner_status: data?.banner_status,
                    banner_link: data?.banner_link,
                    banner_name: data?.banner_name,
                    banner_status_open: data?.banner_status_open,
                    id_media_file: data?.id_media_file,
                    is_public: data?.is_public,
                    banner_end_time: data?.banner_end_date ? moment(data?.banner_end_date).format("HH:mm") : "",
                    banner_start_time: data?.banner_start_date ? moment(data?.banner_start_date).format("HH:mm") : "",
                    seq: data?.seq,
                    status: data?.status
                }))
            }
        }).catch((err) => {
            console.log(err, 'err')
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }


    useEffect(() => {
        if (id && !isNaN(+id)) {
            handleGetDetail(+id)
        }
    }, [])

    return (
        <ContainerLayout
            title=''
            titleName={id ? 'รายละเอียดแบนเนอร์' : 'เพิ่มแบนเนอร์'}
            enablePadding
            navigateContent={
                <NavigateListCustom
                    navigateData={
                        [
                            {
                                key: "โครงสร้างเว็บไซต์",
                                name: "โครงสร้างเว็บไซต์",
                                pathName: "",
                                disabled_match: true
                            },
                            {
                                key: "แบนเนอร์สไลด์",
                                name: "แบนเนอร์สไลด์",
                                pathName: routeName.cms_website.website_structure_banner_slide_list,
                            },
                            {
                                key: "website_structure_banner_slide",
                                name: banner_group_data?.find((x) => x.value === group_type)?.label || "-",
                                pathName: routeName.cms_website.website_structure_banner_slide,
                                searchParams: {
                                    group_type: group_type
                                }
                            },
                            ...((id && view) ? [
                                {
                                    key: "รายละเอียดแบนเนอร์",
                                    name: "รายละเอียดแบนเนอร์",
                                    pathName: routeName.cms_website.website_structure_banner_slide_view.replace(":id", id),
                                }] : (id && !view) ? [
                                    {
                                        key: "รายละเอียดแบนเนอร์",
                                        name: "รายละเอียดแบนเนอร์",
                                        pathName: routeName.cms_website.website_structure_banner_slide_detail.replace(":id", id),
                                    },
                                ] : [
                                {
                                    key: "เพิ่มแบนเนอร์",
                                    name: "เพิ่มแบนเนอร์",
                                    pathName: routeName.cms_website.website_structure_banner_slide_create,
                                },
                            ])
                        ]}
                />
            }

            buttonContent={
                <ContainerButton
                    justifyContent='flex-end'
                    buttonData={[
                        {
                            key: "BACK",
                            buttonProps: {
                                onClick: () => navigate(-1)
                            },
                            hidden: view,
                            label: "ย้อนกลับ",
                            seq: 1,
                            type: "BACK"
                        },
                        // {
                        //     key: "SAVE_DRAFT",
                        //     buttonProps: {
                        //         onClick: () => handleSubmit("DRAFT")
                        //     },
                        //     hidden: formState.status !== STATUS_DATA.DRAFT || view,
                        //     label: "บันทึกร่าง",
                        //     seq: 2,
                        //     type: "SAVE_DRAFT"
                        // },
                        {
                            key: "SAVE",
                            hidden: view,
                            buttonProps: {
                                onClick: () => handleSubmit("SUBMIT", id_media_file || undefined)
                            },
                            label: "บันทึก",
                            seq: 3,
                            type: "SAVE"
                        },
                    ]}
                />
            }
            content={
                <div className='w-full'>
                    <StateComponents
                        disabledAllField={view}
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "SWITCH",
                                gridProps: {
                                    xs: 12
                                },
                                fieldProps: {
                                    disabled: view,
                                    checked: formState.is_public ? true : false,
                                    onChange: (val) => {
                                        handleChangeFormState('is_public', val ? 1 : 0);
                                    },
                                    label: "สถานะการเผยแพร่"
                                }
                            },
                            {
                                seq: 2,
                                type: "DATE",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    onChange: (date) => handleChangeFormState('banner_start_date', date),
                                    value: formState.banner_start_date,
                                    heading: "วันที่เริ่มต้นเผยแพร่",
                                    placeholder: "ระบุ"
                                }
                            },
                            {
                                seq: 3,
                                type: "DATE",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    disabled: view || !formState.banner_start_date,
                                    disableStartDate: formState.banner_start_date,
                                    onChange: (date) => handleChangeFormState('banner_end_date', date),
                                    value: formState.banner_end_date,
                                    heading: "วันที่สิ้นสุดเผยแพร่",
                                    placeholder: "ระบุ"
                                }
                            },
                            {
                                seq: 4,
                                type: "TIME_PICKER",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    value: formState.banner_start_time,
                                    onChange: (e) => handleChangeFormState('banner_start_time', e),
                                    heading: "เวลาที่เริ่มต้นเผยแพร่",
                                    placeholder: "ระบุ"
                                }
                            },
                            {
                                seq: 5,
                                type: "TIME_PICKER",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    value: formState.banner_end_time,
                                    onChange: (e) => {
                                        handleChangeFormState('banner_end_time', e)
                                    },
                                    heading: "เวลาที่สิ้นสุดเผยแพร่",
                                    placeholder: "ระบุ"
                                }
                            },
                            {
                                seq: 6,
                                type: "UPLOAD_IMAGE_PREVIEW",
                                gridProps: {
                                    xs: 12,
                                },
                                fieldProps: {
                                    image_file_blob: image_upload[0],
                                    heading: "ภาพแบนเนอร์",
                                    sub_heading: "ขนาดภาพที่แนะนำ 1920x628px",
                                    onChange: (val) => set_image_upload(val),
                                    onClear: () => {
                                        set_image_upload([]);
                                        set_file_api_url("");
                                    },
                                    view: view,
                                    disabled: true,
                                    image_file_url: file_api_url,
                                    multiple: false,
                                    onClick: () => setShowModal("ADD"),
                                }
                            },
                            {
                                seq: 7,
                                type: "TEXT-MASK",
                                gridProps: {
                                    xs: 5,
                                    md: 1
                                },
                                fieldProps: {
                                    mode: "number",
                                    heading: "ลำดับ",
                                    required: true,
                                    helperText: errorMessage.seq,
                                    placeholder: "ระบุ",
                                    onChange: (e) => {
                                        handleChangeFormState('seq', e.target.value);
                                        clearErrorMessage();
                                    },
                                    value: `${formState.seq || ""}`,
                                }
                            },
                            {
                                seq: 8,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                },
                                fieldProps: {
                                    heading: "ชื่อ",
                                    placeholder: "ระบุ",
                                    required: true,
                                    helperText: errorMessage.banner_name,
                                    onChange: (e) => {
                                        handleChangeFormState('banner_name', e.target.value);
                                        clearErrorMessage();
                                    },
                                    value: formState.banner_name,
                                }
                            },
                            {
                                seq: 9,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                },
                                fieldProps: {
                                    heading: "ลิงก์เชื่อมโยง",
                                    placeholder: "ระบุ",
                                    required: true,
                                    helperText: errorMessage.banner_link,
                                    onChange: (e) => {
                                        handleChangeFormState('banner_link', e.target.value);
                                        clearErrorMessage();
                                    },
                                    value: formState.banner_link,
                                }
                            },
                            {
                                seq: 10,
                                type: "RADIO",
                                gridProps: {
                                    xs: 12,
                                },
                                fieldProps: {
                                    row: true,
                                    onChange: (e) => handleChangeFormState('banner_status_open', e.target.value),
                                    value: formState.banner_status_open,
                                    dataList: [
                                        {
                                            label: "อยู่ในหน้าเดิม",
                                            value: MENU_RENDER_VIEW_ENUM.CURRENT_TAB
                                        },
                                        {
                                            label: "เปิดหน้าใหม่",
                                            value: MENU_RENDER_VIEW_ENUM.NEW_TAB
                                        }
                                    ],
                                    heading: "การแสดงผล",
                                }
                            },
                        ]}
                    />

                    {showModal !== "" && (
                        <ModalMedia
                            open
                            handleClose={handleCloseModal}
                            title='เพิ่มไฟล์'
                            id_media_file={id_media_file}
                            onSelectMediaFile={(_, id) => set_id_media_file(id)}
                            onSubmitMediaFile={async (_, id_media_file) => {
                                handleCloseModal();
                                const path = await linkPreviewImage(id_media_file);
                                set_file_api_url(path);
                                setFormState((prev) => ({ ...prev, id_media_file }))
                                // handleSubmit(id_media_file);
                            }}
                            onSubmitLocalFile={async (id_media_file) => {
                                const path = await linkPreviewImage(id_media_file);
                                setFormState((prev) => ({ ...prev, id_media_file }))
                                set_file_api_url(path);
                                handleCloseModal();
                                // handleSubmit(id_media_file);
                            }}
                        />
                    )}
                </div>
            }
        />
    )
}

export default BannerSlideDetail